import * as Parse from 'parse'
import { FunctionNames, Params, Responses } from '../../../../../server/src/shared-with-client/endpoint-definitions'
import { Objects } from '../../../../../server/src/shared-with-client/object-definitions'

// const defaultPropertyDataSource: Objects.PropertyData.Source = 'property-data'

export class MailingListService {
    public async runDuplicateDetection(establishmentId: string, mailingListId: string) {
        const params: Params.MailingList.RunAgainstDuplicateDetection = {
            establishmentId,
            mailingListId,
        }
        const fn: FunctionNames.MailingList.RunAgainstDuplicateDetection = 'runMailingListAgainstDuplicateDetection'
        const response: Responses.MailingList.RunAgainstDuplicateDetection = await Parse.Cloud.run(fn, params)

        return response
    }

    public async getAreaDetailsForListUpdate(establishmentId: string, mailingListOrderId: string) {
        const params: Params.MailingListOrder.GetAreaDetailsForListUpdate = {
            establishmentId,
            mailingListOrderId,
        }

        const fn: FunctionNames.MailingListOrder.GetAreaDetailsForListUpdate = 'getMailingListOrderAreaDetailsForListUpdate'
        const response: Responses.MailingListOrder.GetAreaDetailsForListUpdate = await Parse.Cloud.run(fn, params)
        return response
    }

    public async getAreaDetailsForAddressAndRadius(
        establishmentId: string,
        radius: number,
        propertyTypeOptions: Objects.PropertyData.PropertyTypeOptions,
        opts: Params.MailingListOrder.GetAreaDetailsForAddressAndRadius['opts']
    ) {
        const params: Params.MailingListOrder.GetAreaDetailsForAddressAndRadius = {
            establishmentId,
            propertyTypeOptions,
            radius,
            opts,
        }

        const fn: FunctionNames.MailingListOrder.GetAreaDetailsForAddressAndRadius = 'getMailingListOrderAreaDetailsForAddressAndRadius'
        const response: Responses.MailingListOrder.GetAreaDetailsForAddressAndRadius = await Parse.Cloud.run(fn, params)
        return response
    }

    public async getAreaDetailsForAddressAndRadiusWithinPolygon(
        establishmentId: string,
        addressLimit: number,
        street: string,
        city: string,
        radius: number,
        state: string,
        coordinates: { lat: number; lon: number }[],
        propertyTypeOptions: Objects.PropertyData.PropertyTypeOptions,
        source: Objects.PropertyData.Source,
        advancedFilters: Objects.PropertyData.V3.FindWithPolygonV3RequestData.AdvancedFilters | undefined
    ) {
        const params: Params.MailingListOrder.GetAreaDetailsForPolygon = {
            addressLimit,
            coordinates,
            street,
            city,
            establishmentId,
            propertyTypeOptions,
            radius,
            state,
            source,
            advancedFilters,
        }

        const fn: FunctionNames.MailingListOrder.GetAreaDetailsForPolygon = 'getMailingListOrderAreaDetailsForPolygon'
        const response: Responses.MailingListOrder.GetAreaDetailsForPolygon = await Parse.Cloud.run(fn, params)
        return response
    }

    public async getSaturationRateForPolygon(establishmentId: string, coordinates: { lat: number; lon: number }[]) {
        const params: Params.MailingListOrder.GetSaturationRateForPolygon = {
            establishmentId,
            coordinates,
        }

        const fn: FunctionNames.MailingListOrder.GetSaturationRateForPolygon = 'getMailingListOrderSaturationRateForPolygon'
        const response: Responses.MailingListOrder.GetSaturationRateForPolygon = await Parse.Cloud.run(fn, params)
        return response
    }

    public async getTurnoverRateForPolygon(
        establishmentId: string,
        coordinates: { lat: number; lon: number }[],
        propertyTypeOptions: Objects.PropertyData.PropertyTypeOptions,
        advancedFilters: Objects.PropertyData.V3.FindWithPolygonV3RequestData.AdvancedFilters | undefined
    ) {
        const params: Params.MailingListOrder.GetTurnoverRateForPolygon = {
            establishmentId,
            coordinates,
            advancedFilters,
            propertyTypeOptions,
        }

        const fn: FunctionNames.MailingListOrder.GetTurnoverRateForPolygon = 'getMailingListOrderTurnoverRateForPolygon'
        const response: Responses.MailingListOrder.GetTurnoverRateForPolygon = await Parse.Cloud.run(fn, params)
        return response
    }

    public async getSaturationRateForAddressAndRadius(
        establishmentId: string,
        street: string,
        city: string,
        radius: number,
        state: string,
        source: Objects.PropertyData.Source,
        coordinate: { lat: number; lon: number }
    ) {
        const params: Params.MailingListOrder.GetSaturationRateForAddressAndRadius = {
            street,
            city,
            establishmentId,
            radius,
            state,
            source,
            coordinate,
        }

        const fn: FunctionNames.MailingListOrder.GetSaturationRateForAddressAndRadius = 'getMailingListOrderSaturationRateForAddressAndRadius'
        const response: Responses.MailingListOrder.GetSaturationRateForAddressAndRadius = await Parse.Cloud.run(fn, params)
        return response
    }

    public async getTurnoverRateForAddressAndRadius(
        establishmentId: string,
        street: string,
        city: string,
        radius: number,
        state: string,
        source: Objects.PropertyData.Source,
        coordinate: { lat: number; lon: number },
        propertyTypeOptions: Objects.PropertyData.PropertyTypeOptions,
        advancedFilters: Objects.PropertyData.V3.FindWithPolygonV3RequestData.AdvancedFilters | undefined
    ) {
        const params: Params.MailingListOrder.GetTurnoverRateForAddressAndRadius = {
            street,
            city,
            establishmentId,
            radius,
            state,
            source,
            coordinate,
            propertyTypeOptions,
            advancedFilters,
        }

        const fn: FunctionNames.MailingListOrder.GetTurnoverRateForAddressAndRadius = 'getMailingListOrderTurnoverRateForAddressAndRadius'
        const response: Responses.MailingListOrder.GetTurnoverRateForAddressAndRadius = await Parse.Cloud.run(fn, params)
        return response
    }

    public async getAreaDetailsWithinGeoId(establishmentId: string, geoIdV4: string, propertyTypeOptions: Objects.PropertyData.PropertyTypeOptions) {
        const params: Params.MailingListOrder.GetAreaDetailsWithinGeoId = {
            establishmentId,
            geoIdV4,
            propertyTypeOptions,
        }

        const fn: FunctionNames.MailingListOrder.GetAreaDetailsWithinGeoId = 'getMailingListOrderAreaDetailsWithinGeoId'
        const response: Responses.MailingListOrder.GetAreaDetailsWithinGeoId = await Parse.Cloud.run(fn, params)
        return response
    }
}
